module.exports = __webpack_public_path__ + "static/media/hiw-services.0b8e80fb.svg";